export default __webpack_public_path__ + "static/media/services2.b0b44ea3.png";